// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"mobility-plan-tooltip_wrapper__ImtX6","title":"mobility-plan-tooltip_title__sm2LS","releaseChecklist":"mobility-plan-tooltip_releaseChecklist__3btR1"};